export default {
  dy: '电影（含网络电影）',
  ds: '电视剧（含网络电视剧）',
  dm: '动漫（含网络动漫）',
  cy: '关联产业产品',
  dj: '微短剧'
}
